// extracted by mini-css-extract-plugin
export default {"container":"_2JDbP","title":"bITCx","post":"Lk1fH"};